"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_LOCALE = exports.PERCENTAGE_FORMAT_OPTIONS = exports.CURRENCY_FORMAT_OPTIONS = exports.FORMAT_OPTIONS = void 0;
exports.FORMAT_OPTIONS = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
};
exports.CURRENCY_FORMAT_OPTIONS = Object.assign(Object.assign({}, exports.FORMAT_OPTIONS), { currency: 'EUR', style: 'currency' });
exports.PERCENTAGE_FORMAT_OPTIONS = Object.assign(Object.assign({}, exports.FORMAT_OPTIONS), { style: 'percent' });
exports.DEFAULT_LOCALE = 'de-DE';
